import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { resolvePrefillBrain, resolvePrefillEmail } from "./leadModalPrefill.js";

const DESKTOP_FOCUS_MIN_WIDTH = 768;

export function useLeadModalPrefill(isOpen, setEmail) {
  const [searchParams] = useSearchParams();
  const emailInputRef = useRef(null);
  const initialBotType = useMemo(
    () => resolvePrefillBrain(searchParams),
    [searchParams],
  );

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const resolvedEmail = resolvePrefillEmail(searchParams);
    if (resolvedEmail) {
      setEmail(resolvedEmail);
    }
  }, [isOpen, searchParams, setEmail]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_FOCUS_MIN_WIDTH}px)`).matches;
    if (!isDesktop) return undefined;

    const timer = window.setTimeout(() => {
      emailInputRef.current?.focus();
    }, 120);

    return () => window.clearTimeout(timer);
  }, [isOpen]);

  return { emailInputRef, initialBotType };
}
